import React from "react";
import AuthorizationCheck from "../auth/authorizationCheck";
import Utility from "../utilities/utility";
import OrderService from "../services/order";

class GenerateOrderUniqueNumbers extends React.Component {

    constructor(props) {
        super(props);

        

        this.state = {
            loading: false,
            result: null,
            currentUserRole: ''
        };
    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    generateOrderUniqueNumbers = async () => {
        try {
            this.setState({
                loading: true,
                result: null
            });

            const response =
                await OrderService.generateOrderUniqueNumbers();

            const result = await response.json();

            if (!response.ok) {
                Utility.showAlertWithId(
                    "errorHolder",
                    result.message || "Impossible de générer les numéros de commande",
                    "danger",
                    true
                );

                this.setState({
                    loading: false
                });

                return;
            }

            this.setState({
                loading: false,
                result: result
            });

            Utility.showAlertWithId(
                "errorHolder",
                "Numéros de commande générés avec succès",
                "success",
                true
            );

        } catch (error) {
            console.log(error);

            this.setState({
                loading: false
            });

            Utility.showAlertWithId(
                "errorHolder",
                "Impossible de générer les numéros de commande",
                "danger",
                true
            );
        }
    }

    render() {
        return (
            <div className="container mt-4">

                <AuthorizationCheck accessLevel="MANAGER" userRole={this.setRole} />

                <div id="errorHolder"></div>

                <div className="card shadow-sm">
                    <div className="card-header bg-info text-white">
                        <h5 className="mb-0">
                            Générer les numéros uniques des commandes
                        </h5>
                    </div>

                    <div className="card-body">
                        <p>
                            Cette action va générer un numéro unique pour toutes
                            les commandes existantes qui n'ont pas encore de numéro.
                        </p>

                        <button
                            className="btn btn-primary"
                            onClick={this.generateOrderUniqueNumbers}
                            disabled={this.state.loading}
                        >
                            {this.state.loading
                                ? "Génération en cours..."
                                : "Générer les numéros"}
                        </button>

                        {this.state.result && (
                            <div className="alert alert-success mt-4">
                                <strong>Terminé.</strong>
                                <br />
                                Commandes mises à jour : {this.state.result.updated}
                                <br />
                                {this.state.result.message}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default GenerateOrderUniqueNumbers;